export var SortBy;
(function (SortBy) {
    SortBy["NameAscending"] = "Name (A-Z)";
    SortBy["NameDescending"] = "Name (Z-A)";
})(SortBy || (SortBy = {}));
//# sourceMappingURL=ContactsFilterState.js.map